import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/empresa',
      name: 'empresa',
      component: () => import(/* webpackChunkName: "empresa" */ './views/Empresa')
    },
    {
      path: '/proyectos',
      name: 'proyectos',
      component: () => import(/* webpackChunkName: "proyectos" */ './views/Proyectos')
    },
    {
      path: '/linea-servicio',
      name: 'linea-servicio',
      component: () => import(/* webpackChunkName: "linea-servicio" */ './views/Linea-servicios')
    },
    {
      path: '/linea-servicio/:service',
      name: 'linea-servicio-id',
      component: () => import(/* webpackChunkName: "linea-servicio" */ './views/Linea-servicios')
    },
    {
      path: '/clientes',
      name: 'clientes',
      component: () => import(/* webpackChunkName: "clientes" */ './views/Clientes')
    }, 
    {
      path: "*",
      component: () => import(/* webpackChunkName: "404" */ './views/404'),
      meta: {
        showContact: false
      }
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (to && to.name == 'linea-servicio' && to.params && to.params.service) {
      return { selector: "#lineaServicios" };
    }
    return { x: 0, y: 0 };
  }
})
